function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/OnlineTraining',['vendor/fullpage/vendors/scrolloverflow.min', 'vendor/fullpage/src/fullpage'], function () {
  'use strict';

  /**
   * Online Training javascript application.
   * 
   * @author Michael Bindig <mbi@sopg.de>
   * @jira CHEF-220
   * @jira CHEF-229
   * @jira CHEF-233
   * @jira CHEF-235
   * 
   * @created 2021-02-10
   * @updated 2021-03-16
   * 
   * @type OnlineTraining
   */
  var OnlineTraining = /*#__PURE__*/function () {
    /**
     * Constructor.
     * 
     * @author Michael Bindig <mbi@sopg.de>
     * 
     * @created 2021-02-10
     * @updated 2021-03-16
     * 
     * @param {function}
     * 
     * @returns {OnlineTraining}
     */
    function OnlineTraining(fnLog) {
      var _this = this;
      _classCallCheck(this, OnlineTraining);
      /**
       * Init online training.
       * 
       * @author Lennart Bergmann <lb@sopg.de>
       * 
       * @creatded 2021-03-25
       * 
       * @returns {OnlineTraining}
       */
      _defineProperty(this, "init", function () {
        /* Set height. */
        $('.slide-content-scroll-container').css('min-height', $(window).height());
        $(window).resize(function () {
          $('.slide-content-scroll-container').css('min-height', $(window).height());
        });
        var $initialSlide = $(_this.o.sel.slide + '.' + _this.o.opt.classes.active);
        var iInitialIndex = $initialSlide.attr('data-index') - 1;
        _this.aVisited.push(iInitialIndex);
        _this.updateMenu(-1, iInitialIndex);
        _this.initUrl();
        return _this;
      });
      /**
       * Initializes fullpage js.
       * 
       * @author Lennart Bergmann <lb@sopg.de>
       * 
       * @creatded 2021-03-25
       * 
       * @returns {OnlineTraining}
       */
      _defineProperty(this, "initFullpage", function () {
        _this.oFullPage = new fullpage('.slide-container', {
          licenseKey: '2F36CCBD-861D4131-BB49D636-8F78B628',
          sectionSelector: '.slide',
          scrollOverflow: true,
          normalScrollElements: '#s3-1-range-slider1, #s22-1-modal-m2, .share-toggle-button',
          onLeave: function onLeave(oCurrent, oNext, sDirection) {
            /* Push to visited */
            _this.aVisited.push(oNext.index);

            /* Update Menu */
            _this.updateMenu(oCurrent.index, oNext.index);

            /* Change history */
            _this.changeHistoryState($(oNext.item));
          }
        });
        _this.oFullPage.reBuild();
        window.fullpage = _this.oFullPage;
        return _this;
      });
      /**
       * CSS selectors 
       * and options.
       * @type Object
       */
      this.o = {
        sel: {
          slide: '.js-slide',
          inner: '.js-inner-scroll',
          scrollContainer: '.js-scroll-container',
          /* Added 2021-03-01, CHEF-233 */
          menu: '.js-menu',
          /* Added 2021-03-09, CHEF-235 */
          overlayOpener: '.js-overlay-opener',
          overlay: '.modal-overlay',
          overlayCloser: '.modal-close',
          rangeInput: '.range-slider',
          targetContainer: '.dd-sc-target-container'
        },
        opt: {
          directory: 'online-training',
          event: {
            enter: {
              start: 'enter.start',
              end: 'enter.end'
            },
            leave: {
              start: 'leave.start',
              end: 'leave.end'
            }
          },
          classes: {
            active: 'active',
            completed: 'completed',
            disabled: 'disabled',
            rangeSlider: 'range-slider',
            dontMove: 'dont-move'
          },
          data: {
            key: 'data-key',
            index: 'data-index',
            lesson: 'data-lesson',
            timeline: 'timeline'
          },
          speed: {
            /* Slide transition 
            speed in seconds. */
            slideTransition: 0.6,
            /* Inner scroll 
            speed in seconds. */
            innerScroll: 0.35,
            /* Jump to transition 
            speed in seconds,
            added 2021-03-01, CHEF-229 */
            jumpTo: 0.25
          },
          ease: {
            /* Slide transition easing. */
            slideTransition: Power1.easeInOut,
            /* Inner scroll 
            transition easing. */
            innerScroll: Power1.easeInOut,
            /* Jump to transition,
            added 2021-03-01, CHEF-229 */
            jumpTo: Power1.easeInOut
          },
          factor: {
            /* Inner scroll 
            mouse wheel factor. */
            innerScroll: 3
          },
          /* Throttle scrolling/slide switching. */
          scrollTimeout: 300
        }
      };

      /**
       * Slides collection.
       * @type jQuery
       */
      this.$slides = $(this.o.sel.slide);

      /**
       * Indexes of already 
       * visited slides.
       * @jira CHEF-233
       * @added 2021-03-01
       * @type Array
       */
      this.aVisited = [];

      /**
       * Base URL.
       * @type String
       */
      this.sBaseUrl = '';

      /**
       * Last touch 
       * start position.
       * @type Number
       */
      this.iTouchStart = 0;

      /**
       * Busy state.
       * @type Boolean
       */
      this.isBusy = false;

      /**
       * Scroll listeners/iScrolls.
       * @jira CHEF-235
       * @added 2021-03-08
       * @type array
       */
      this.aScrolls = [];

      /**
       * Resize timeout.
       * @jira CHEF-235
       * @added 2021-03-09
       * @type object
       */
      this.oResizeTimeout = null;

      /**
       * Is a popup open.
       * @jira CHEF-235
       * @type {bool}
       */
      this.bPopupOpen = false;

      /**
       * Should scroll events fire.
       * @jira CHEF-235
       * @type {bool}
       */
      this.bDontScroll = false;

      /**
       * Timeout to throttle scrolling.
       * @jira CHEF-235
       * @type {object}
       */
      this.oScrollTimeout = null;

      /**
       * Log function.
       * @jira CHEF-235
       * @type {function}
       */
      this.log = fnLog;

      /**
       * Fullpage object.
       * @jira CHEF-235
       * @type {object}
       */
      this.oFullPage = null;

      /* Init. */
      this.init().initFullpage();
    }
    return _createClass(OnlineTraining, [{
      key: "initUrl",
      value:
      /**
       * Initializes the browser's URL and 
       * makes it match with the current slide.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2021-02-15
       * @updated 2021-03-12
       * 
       * @returns {OnlineTraining}
       */
      function initUrl() {
        var _this2 = this;
        var sPath = window.location.pathname;

        /* Set the base URL. */
        this.sBaseUrl = sPath.substr(0, sPath.indexOf(this.o.opt.directory) + this.o.opt.directory.length);

        /* Create an onpostate event callback, 
        that switches to the URL requested slide 
        after pushing browser's back or forward button.  */
        window.onpopstate = function (oEvent) {
          var $activeSlide = $(_this2.o.sel.slide + '.' + _this2.o.opt.classes.active);
          var $urlSlide = _this2.getUrlSlide();
          if ($activeSlide.attr(_this2.o.opt.data.index) > $urlSlide.attr(_this2.o.opt.data.index)) {
            _this2.prev(0, $activeSlide, $urlSlide, true);
          } else if ($activeSlide.attr(_this2.o.opt.data.index) < $urlSlide.attr(_this2.o.opt.data.index)) {
            _this2.next(0, $activeSlide, $urlSlide, true);
          }
        };

        /* Replace the history state initially. */
        this.changeHistoryState(this.getUrlSlide(), true);
        return this;
      }

      /**
       * Jumps to the given slide, 
       * flying over all between slides.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * @author Lennart Bergmann <lb@sopg.de>
       * @jira CHEF-229
       * @jira CHEF-235
       * 
       * @created 2021-03-01
       * @updated 2021-03-26
       * 
       * @param {jQuery} $slide
       * @returns {undefined}
       */
    }, {
      key: "jumpTo",
      value: function jumpTo($slide) {
        /* Allow scrolling which was disable when the menu opened. */
        window.fullpage.setAllowScrolling(true);
        window.fullpage.setKeyboardScrolling(true);
        this.oFullPage.moveTo($slide.attr(this.o.opt.data.index));
        return;
      }

      /**
       * Switches to the next slide.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * @author Lennart Bergmann <lb@sopg.de>
       * @jira CHEF-235
       * 
       * @created 2021-02-11
       * @updated 2021-03-26
       * 
       * @returns {OnlineTraining} 
       */
    }, {
      key: "next",
      value: function next() {
        this.oFullPage.moveSectionDown();
        return this;
      }

      /**
       * Switches to the previous slide.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * @author Lennart Bergmann <lb@sopg.de>
       * 
       * @created 2021-02-11
       * @updated 2021-03-26
       *
       * @returns {OnlineTraining} 
       */
    }, {
      key: "prev",
      value: function prev() {
        this.oFullPage.moveSectionUp();
        return this;
      }

      /**
       * Updates the menu's section links.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * @author Lennart Bergmann <lb@sopg.de>
       * @jira CHEF-233
       * @jira CHEF-235
       * 
       * @created 2021-03-01
       * @created 2021-03-23
       * 
       * @returns {OnlineTraining}
       */
    }, {
      key: "updateMenu",
      value: function updateMenu(iCurrent, iNext) {
        var _this3 = this;
        $(this.o.sel.menu).find('a').each(function (iIndex, oElem) {
          var $item = $(oElem);
          var sSlides = $item.attr('data-slides');
          if ('undefined' !== typeof sSlides) {
            var aSlides = sSlides.split(',');
            if (aSlides.includes(iCurrent.toString())) {
              $item.removeClass(_this3.o.opt.classes.active);
            }

            /* Slides can include the indexes of both, 
               the current and next slide. */
            if (aSlides.includes(iNext.toString())) {
              $item.addClass(_this3.o.opt.classes.active);
            }
            var bVisited = aSlides.every(function (iIndex) {
              /* For some reason iIndex is a string. */
              return -1 < _this3.aVisited.indexOf(parseInt(iIndex));
            });
            if (bVisited) {
              $item.addClass(_this3.o.opt.classes.completed);
            }
          }
        });
        return this;
      }

      /**
       * Changes the browser's history state. 
       * 
       * If bReplace is set to TRUE, the old/current 
       * history state will be replaced, otherwise 
       * the new one will be pushed.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2021-02-16
       * @updated 2021-02-18
       * 
       * @param {jQuery} $slide
       * @param {Boolean} bReplace
       * @returns {OnlineTraining}
       */
    }, {
      key: "changeHistoryState",
      value: function changeHistoryState($slide) {
        var bReplace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var sUrl = this.getSlideUrl($slide);
        if (bReplace) {
          history.replaceState({}, '', sUrl);
        } else {
          history.pushState({}, $slide.attr('id'), sUrl);
        }
        return this;
      }

      /**
       * Returns the given slide's URL.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2021-02-16
       * 
       * @param {jQuery} $slide
       * @returns {String}
       */
    }, {
      key: "getSlideUrl",
      value: function getSlideUrl($slide) {
        var sLesson = $slide.attr(this.o.opt.data.lesson);
        var sKey = $slide.attr(this.o.opt.data.key);
        return this.sBaseUrl + '/' + sLesson + '/' + sKey + '/';
      }

      /**
       * Returns the slide, represented 
       * by the current browser URL.
       * 
       * @author Michael Bindig <mbi@sopg.de>
       * 
       * @created 2021-02-18
       * 
       * @returns {jQuery}
       */
    }, {
      key: "getUrlSlide",
      value: function getUrlSlide() {
        /* Pre-define the slide tha is 
        used for building the browser URL. */
        var $urlSlide = this.$slides.eq(0);
        var sPath = window.location.pathname;
        var sSubPath = sPath.substr(sPath.indexOf(this.o.opt.directory) + this.o.opt.directory.length);
        var aSubPath = sSubPath.split('/').filter(function (sPart) {
          return 0 < sPart.length;
        });
        if (2 === aSubPath.length) {
          var sSelector = '[' + this.o.opt.data.key + '="' + aSubPath[1] + '"]';
          if (0 < this.$slides.filter(sSelector).length) {
            /* Re-set he slide that is 
            used for building the browser URL. */
            $urlSlide = this.$slides.filter(sSelector);
          }
        }
        return $urlSlide;
      }
    }]);
  }();
  return OnlineTraining;
});

